// Session 过期事件管理模块
// 用于 ApiClient 和 AuthGuard 之间的通信

type SessionExpiredCallback = () => void

let isHandling = false
let callbacks: SessionExpiredCallback[] = []

export const AuthEvents = {
	// 触发 session expired 事件
	triggerSessionExpired: () => {
		if (isHandling) return
		isHandling = true
		callbacks.forEach(cb => cb())
	},

	// 订阅 session expired 事件
	onSessionExpired: (callback: SessionExpiredCallback) => {
		callbacks.push(callback)
		return () => {
			callbacks = callbacks.filter(cb => cb !== callback)
		}
	},

	// 重置状态（登录成功后调用）
	reset: () => {
		isHandling = false
	}
}
